import { render, staticRenderFns } from "./Proofing.vue?vue&type=template&id=7bbf3df4&scoped=true"
import script from "./Proofing.vue?vue&type=script&lang=js"
export * from "./Proofing.vue?vue&type=script&lang=js"
import style0 from "./Proofing.vue?vue&type=style&index=0&id=7bbf3df4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbf3df4",
  null
  
)

export default component.exports